
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/accounts/register",
      function () {
        return require("private-next-pages/accounts/register/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/accounts/register"])
      });
    }
  